module.exports = __webpack_public_path__ + "static/media/app-store-badge-en.e8548eaa.svg";